import React, {useContext, useEffect} from 'react';

import { Row } from "react-bootstrap";
import TitlePage from '../../components/TitlePage';
import CardImgProfile from '../../components/Profile/CardImgProfile';
import CardInfoUser from '../../components/Profile/CardInfoUser';

import UserContext from '../../context/User/UserContext';
import ComplementContext from "../../context/Complement/ComplementContext";

import {toBase64} from '../../utils/FileUtil';

import FormProfile from './form';

const Profile = () => {
     
    const userContext = useContext(UserContext);
    const complementContext = useContext(ComplementContext);
    
    const { user, file, loading, loadingFile, getDataUser, getImgAccount, updateDataAccount, uploadImgAccount } = userContext;
    const { afp, isapre, region} = complementContext;
 
    useEffect(  () => {        
        const callDataUser = async () => {
             getDataUser();
        }
        if(!user){callDataUser();}
        if(user && !file){getImgAccount(user.img)}
        // eslint-disable-next-line
    }, [user])

    const uploadFile = async (data) => {
        
        const array = data.name.split(".");
        const extension = array[array.length -1];
        const type = data.type;
        const fileBase64 = await toBase64(data);
        const file = fileBase64.split(';base64,')[1];
        uploadImgAccount(file, extension, type)
    }
   
    return ( 
        <>   
            <TitlePage title={"Mi Perfil"} />

            <Row >                     
                <CardImgProfile 
                    colSize={3} 
                    load={loading}
                    loadImg={loadingFile}
                    name={user ? `${user.firstName} ${user.lastName}` : ''}
                    img={file ? `${file.file}` : null}
                    formatImg={file ? `${file.extension}` : null}
                    eventUploadFile={uploadFile}
                    accept={'.jpg, .png'}
                    />

                <CardInfoUser 
                    colSize={9}
                    load={loading}
                    user={user}
                    afp={afp} 
                    isapre={isapre} 
                    region={region} 
                    sendEvent={updateDataAccount}
                > 
                    <FormProfile 
                                colSize={9} 
                                user={user} 
                                afp={afp} 
                                isapre={isapre} 
                                region={region} 
                                sendEvent={updateDataAccount}
                            />
                </CardInfoUser>
                
            </Row>
            
        </>
     );
}
 
export default Profile;